/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/Prime.json';
import { Prime } from 'libs/contracts/generated/infos/contractTypes';
import { getUniqueContractAddress } from 'libs/contracts/utilities/getUniqueContractAddress';
import { useChainId, useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetPrimeContractAddressInput {
  chainId: ChainId;
}

export const getPrimeContractAddress = ({ chainId }: GetPrimeContractAddressInput) =>
  getUniqueContractAddress({ name: 'Prime', chainId });

export const useGetPrimeContractAddress = () => {
  const { chainId } = useChainId();

  return useMemo(
    () =>
      getPrimeContractAddress({
        chainId,
      }),
    [chainId],
  );
};

interface GetPrimeContractInput {
  chainId: ChainId;
  signerOrProvider: Signer | Provider;
}

export const getPrimeContract = ({ chainId, signerOrProvider }: GetPrimeContractInput) => {
  const address = getPrimeContractAddress({ chainId });
  return address ? (new Contract(address, abi, signerOrProvider) as Prime) : undefined;
};

interface UseGetPrimeContractInput {
  passSigner?: boolean;
  chainId?: ChainId;
}

export const useGetPrimeContract = (input?: UseGetPrimeContractInput) => {
  const { chainId: currentChainId } = useChainId();
  const chainId = input?.chainId || currentChainId;

  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = input?.passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getPrimeContract({
            chainId,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, chainId],
  );
};
